import React from 'react'
import { Helmet } from 'react-helmet-async'
import ServicePageTemplate, { ServicePageConfig } from '../../../components/templates/ServicePageTemplate'

const educationConfig: ServicePageConfig = {
  title: 'Education Consulting - FGA Prestige',
  description: 'Expert guidance for elite educational opportunities.',
  slug: 'education-consulting',
  heroImage: '/Member Services/Education Consulting/hero.png',
  serviceName: 'EDUCATION CONSULTING',
  whySectionA: {
    title: 'Pioneering Education Without Boundaries',
    content: 'We believe education should inspire, challenge, and expand possibilities far beyond the classroom. Our bespoke education service opens doors to transformative opportunities—whether through immersive global programs, such as the Space X Summer Camp unlocking curiosity in science and technology, or through tailored pathways to the world’s finest universities. Every journey is carefully crafted to align with each child’s ambitions, nurturing not only academic success but also lifelong confidence.',
    image: '/Member Services/Education Consulting/body/1.png',
    imageAlt: 'Elite Educational Institutions Access'
  },
  whySectionC: {
    title: 'Expert Guidance to the World\'s Top Schools',
    content: 'Our team of dedicated education consultants provides personalised mentorship through the complex world of school and university admissions. From early academic planning to navigating applications for the Ivy League and leading institutions such as Harvard, Yale, Princeton, and Stanford, our expertise ensures families receive discreet yet powerful support at every step. With an eye for both the details and the bigger picture, we position each student for success in the most competitive environments.',
    image: '/Member Services/Education Consulting/body/2.png',
    imageAlt: 'Elite Educational Institutions Access'
  },
  whySectionB: {
    title: 'A Story of Aspiration Realised',
    benefits: [
      {
        title: '',
        description: 'One of our members approached us with a dream for their son—gaining a place at MIT, one of the world\'s most prestigious centres of innovation. With careful preparation, from shaping a compelling personal narrative to arranging mentorship with field specialists, we guided the family through every stage of the process. Months of collaboration came to fruition with the acceptance letter in hand—a life-changing moment that transformed aspiration into achievement.'
      }
    ],
    image: '/Member Services/Education Consulting/body/3.png',
    imageAlt: 'Education Consulting Services'
  },
  masterpieceBackgroundImage: '/Member Services/Education Consulting/CTA Banner/banner.png'
}

const EducationConsultingPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Education Consulting | Member Services | FGA Prestige</title>
        <meta name="description" content="Expert guidance for elite educational opportunities. Personalized mentorship for Ivy League admissions, specialized programs, and academic excellence at FGA Prestige." />
        <link rel="canonical" href="https://fgaprestige.com/member-services/education-consulting" />
        <meta property="og:title" content="Education Consulting | Member Services | FGA Prestige" />
        <meta property="og:description" content="Expert guidance for elite educational opportunities. Personalized mentorship for Ivy League admissions, specialized programs, and academic excellence at FGA Prestige." />
        <meta property="og:url" content="https://fgaprestige.com/member-services/education-consulting" />
        <meta property="og:image" content="/Member Services/Education Consulting/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Education Consulting Services" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Education Consulting | Member Services | FGA Prestige" />
        <meta name="twitter:description" content="Expert guidance for elite educational opportunities. Personalized mentorship for Ivy League admissions, specialized programs, and academic excellence at FGA Prestige." />
        <meta name="twitter:image" content="/Member Services/Education Consulting/hero.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Education Consulting",
            "description": "Expert guidance for elite educational opportunities. Personalized mentorship for Ivy League admissions, specialized programs, and academic excellence at FGA Prestige.",
            "provider": {
              "@type": "Organization",
              "name": "FGA Prestige",
              "url": "https://fgaprestige.com"
            },
            "url": "https://fgaprestige.com/member-services/education-consulting",
            "image": "/Member Services/Education Consulting/hero.png"
          })}
        </script>
      </Helmet>

      <ServicePageTemplate config={educationConfig} />
    </>
  )
}

export default EducationConsultingPage